import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=bded96d0"
import script from "./AddBalance.vue?vue&type=script&lang=js"
export * from "./AddBalance.vue?vue&type=script&lang=js"
import style0 from "./AddBalance.vue?vue&type=style&index=0&id=bded96d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports